// src/pages/Admin/StatistiquesComptabilite/components/ComptaSeasonPanel.jsx

import React from "react";
import {
  FaCalendarAlt,
  FaChevronDown,
  FaSyncAlt,
} from "react-icons/fa";

export default function ComptaSeasonPanel({
  seasons,
  selectedSeason,
  onSeasonChange,
  loadingSettings,
  loadingReglements,
  errorMsg,
  onRefresh,
  openedCount,
  onOpenAll,
  onCloseAll,
}) {
  return (
    <section className="overflow-hidden rounded-[2rem] border border-white/70 bg-white/85 shadow-xl shadow-slate-200/70 backdrop-blur dark:border-slate-800/80 dark:bg-slate-900/70 dark:shadow-black/20">
      <div className="border-b border-slate-200/70 bg-white/70 px-3 py-3 dark:border-slate-800 dark:bg-slate-900/60 sm:px-5">
        <div className="flex flex-col gap-3 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-slate-500 dark:text-slate-400">
              Saison comptable
            </p>

            <h2 className="mt-1 text-xl font-bold text-slate-900 dark:text-white">
              Sélection de la saison
            </h2>

            <p className="mt-1 text-sm leading-6 text-slate-600 dark:text-slate-300">
              {openedCount} section{openedCount > 1 ? "s" : ""} ouverte
              {openedCount > 1 ? "s" : ""}. Les indicateurs sont recalculés à
              chaque changement de saison.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-2 sm:grid-cols-[minmax(0,1fr)_auto] lg:min-w-[460px]">
            <label className="relative">
              <span className="sr-only">Saison</span>

              <FaCalendarAlt className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
              <FaChevronDown className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-slate-400" />

              <select
                value={selectedSeason || ""}
                onChange={(event) => onSeasonChange(event.target.value)}
                disabled={loadingSettings}
                className="min-h-12 w-full appearance-none rounded-2xl border border-slate-200 bg-white px-10 text-sm font-bold text-slate-700 outline-none transition focus:ring-2 focus:ring-indigo-400 disabled:opacity-60 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200"
              >
                {seasons.length === 0 ? (
                  <option value="">Aucune saison</option>
                ) : (
                  seasons.map((season) => (
                    <option key={season} value={season}>
                      Saison {season}
                    </option>
                  ))
                )}
              </select>
            </label>

            <button
              type="button"
              onClick={onRefresh}
              disabled={loadingReglements || !selectedSeason}
              className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 text-sm font-bold text-slate-700 shadow-sm transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-60 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200 dark:hover:bg-slate-800"
            >
              <FaSyncAlt className={loadingReglements ? "animate-spin" : ""} />
              Actualiser
            </button>
          </div>
        </div>

        <div className="mt-3 grid grid-cols-2 gap-2 sm:flex">
          <button
            type="button"
            onClick={onOpenAll}
            className="inline-flex min-h-11 items-center justify-center rounded-2xl bg-[#013E8E] px-4 text-sm font-bold text-white shadow-lg shadow-blue-900/20 transition hover:-translate-y-0.5 hover:bg-indigo-800"
          >
            Tout ouvrir
          </button>

          <button
            type="button"
            onClick={onCloseAll}
            className="inline-flex min-h-11 items-center justify-center rounded-2xl border border-slate-200 bg-white px-4 text-sm font-bold text-slate-700 transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200 dark:hover:bg-slate-800"
          >
            Tout fermer
          </button>
        </div>

        {errorMsg ? (
          <div className="mt-4 rounded-2xl border border-rose-200 bg-rose-50 px-4 py-3 text-sm font-medium text-rose-700 dark:border-rose-500/20 dark:bg-rose-500/10 dark:text-rose-300">
            {errorMsg}
          </div>
        ) : null}
      </div>
    </section>
  );
}